import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';
import 'slick-carousel';

export default () => {
	domContentLoaded(() => {
		$('.js-carousel, .js-voice-carousel, .js-trial-carousel').on('init breakpoint setPosition', (event) => {
			const $boxes = $(event.currentTarget).find('.js-carousel-box');
			let maxHeight = 0;
			$boxes.each((idx, elem) => {
				$(elem).css('height', 'auto');
				const height = Math.floor($(elem).height());
				if (maxHeight < height) {
					maxHeight = height;
				}
			});
			$boxes.height(maxHeight);
		});

		$('.js-carousel').slick({
			slidesToShow: 4,
			adaptiveHeight: true,
			infinite: false,
			prevArrow: '<button type="button" class="c-carousel-arrow prev"></button>',
			nextArrow: '<button type="button" class="c-carousel-arrow next"></button>',
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
			],
		});

		$('.js-voice-carousel, .js-trial-carousel').slick({
			slidesToShow: 3,
			infinite: true,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="c-carousel-arrow prev"></button>',
			nextArrow: '<button type="button" class="c-carousel-arrow next"></button>',
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
			],
		});
	});
};
